import { ColorType } from '../../_ui';
import { FinderStatus } from './types';

interface StatusStyle {
  pillBgColor: ColorType;
  pillLabelColor: ColorType;
  /** Tailwind background class for the per-connector status dot */
  dotClassName: string;
}

const POSITIVE: StatusStyle = {
  pillBgColor: ColorType.POSITIVE0,
  pillLabelColor: ColorType.POSITIVE,
  dotClassName: 'bg-positive1',
};
const WARNING: StatusStyle = {
  pillBgColor: ColorType.WARNING_LIGHT,
  pillLabelColor: ColorType.PAUSED,
  dotClassName: 'bg-warning',
};
const NEGATIVE: StatusStyle = {
  pillBgColor: ColorType.NEGATIVE0,
  pillLabelColor: ColorType.NEGATIVE,
  dotClassName: 'bg-negative1',
};
const NEUTRAL: StatusStyle = {
  pillBgColor: ColorType.GREY2,
  pillLabelColor: ColorType.GREY6,
  dotClassName: 'bg-grey4',
};

export const FINDER_STATUS_STYLE: Record<FinderStatus, StatusStyle> = {
  [FinderStatus.AVAILABLE]: POSITIVE,
  [FinderStatus.OPERATIONAL]: POSITIVE,
  [FinderStatus.IN_USE]: WARNING,
  [FinderStatus.PARTLY_OPERATIONAL]: WARNING,
  [FinderStatus.TEMPORARILY_UNAVAILABLE]: NEGATIVE,
  [FinderStatus.OFFLINE]: NEGATIVE,
  [FinderStatus.UNKNOWN]: NEUTRAL,
};

export const getStatusLabelKey = (status: FinderStatus) => `nearby_chargers_status_${status}`;
